import { autorun } from 'mobx';
import loadRouteFromLocation from './loadRouteFromLocation';
import RootStore from '../RootStore';
import RouterStore from './RouterStore';

interface startRouterConfig {
  defaultRoute?: string;
  html5history?: boolean;
}

declare const window: Window;

const startRouter = (rootStore: RootStore, config: startRouterConfig) => {
  if (!rootStore.routerStore) throw Error('Requires rootStore.routerStore');

  //create director configuration
  const defaultDirectorConfig = {
    html5history: true,
  };

  const directorConfig = Object.assign({}, defaultDirectorConfig, config);
  // console.log('directorConfig', directorConfig);

  loadRouteFromLocation(rootStore, config?.defaultRoute || 'Home');

  return autorun(
    () => {
      const { routerStore } = rootStore;
      if (!routerStore) throw Error('Requires rootStore.routerStore');
      const { currentRoute, params, debugMode } = routerStore as RouterStore;
      const currentPath = routerStore.currentPath as string;
      if (debugMode)
        console.log(
          'window.location.pathname + window.location.search',
          window.location.pathname + window.location.search
        );
      if (currentPath) {
        if (directorConfig.html5history) {
          if (
            currentPath !==
            window.location.pathname + window.location.search
          ) {
            if (debugMode) {
              const currentRoute = routerStore?.currentRoute;
              console.log('window.history.pushState state', {
                routeName: currentRoute?.key,
                params,
              });
            }
            if (debugMode)
              console.log('window.history.pushState url', currentPath);
            window.history.pushState(
              {
                routeName: currentRoute?.key,
                params: params ? { ...params } : undefined,
              },
              '',
              currentPath
            );
          }
        } else {
          const hash = `#${currentPath}`;
          if (hash !== window.location.hash) {
            window.history.pushState(null, '', `/${hash}`);
          }
        }
      } else {
        if (debugMode) console.log('currentPath is null');
      }
    },
    { delay: 300 } // Delay 300ms to allow the currentPath computed to calc
  );
};

export default startRouter;
